import { render, staticRenderFns } from "./Inputs.vue?vue&type=template&id=63f4dd5c&scoped=true"
import script from "./Inputs.vue?vue&type=script&lang=js"
export * from "./Inputs.vue?vue&type=script&lang=js"
import style0 from "./Inputs.vue?vue&type=style&index=0&id=63f4dd5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f4dd5c",
  null
  
)

export default component.exports